<div class="price-container d-flex h-100 w-100 flex-column">
  <div class="d-flex align-items-center justify-content-between w-100 mb-2">
    <div i18n="@@price-details.price" class="price-label">Price</div>
    <div (click)="closeModal()" style="cursor: pointer">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.625 4.375L4.375 15.625"
          stroke="#343330"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.625 15.625L4.375 4.375"
          stroke="#343330"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
  <div class="body">
    <div class="rate mb-1">
      <div class="label" i18n="@@price-details.selling-rate">Selling Rate</div>
      <div class="value">{{ sellingRate }}</div>
    </div>
    <div class="rate mb-1">
      <div class="label" i18n="@@price-details.buying-rate">Buying Rate</div>
      <div class="value">{{ buyingRate }}</div>
    </div>
    <div class="profit">
      <div class="label" i18n="@@price-details.profit">Profit</div>
      <div class="value">{{ profit }}</div>
    </div>
  </div>
</div>
